import { AccessDenied } from "@/auth/organization";
import { ApiError } from "@/lib/http";
import { helpKeyForError } from "@/lib/help-context";

import { Button } from "./Button";
import { ErrorAlert } from "./ErrorAlert";
import { HelpLink } from "./HelpLink";

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  if (error instanceof ApiError && error.status === 403 && error.reason === "PERMISSION_DENIED") {
    return <AccessDenied />;
  }
  return (
    <div className="mx-auto max-w-lg space-y-3 p-6">
      <ErrorAlert error={error} />
      <div className="flex flex-wrap items-center gap-2">
        {onRetry && (
          <Button variant="secondary" onClick={onRetry}>
            Try again
          </Button>
        )}
        <HelpLink helpKey={helpKeyForError(error)} />
      </div>
    </div>
  );
}
